<template>
  <section>
    <draggable ghost-class="ghost" :list="infos.sections">
      <transition-group type="transition" name="list-complete">
        <div
          v-for="(section, index) in configuredSections" 
          :key="index"         
        >
          <div
            v-if="section.pageId === selectedPage"
            :class="[
              'draggable-row', 
              {'mb-3': index + 1 < configuredSections.length}, 
              {'active-section': section.id === navbar.sectionId || section.id === sectionHover}
            ]"
            @click="handleOpenSection(section)"
            @mouseenter="$store.dispatch('setSectionHover', section.id)"
            @mouseleave="$store.dispatch('setSectionHover', '')"              
          >
            <div class="draggable-row-icon">
              <v-icon size="16">fa-regular fa-bars</v-icon>
            </div>

            <div class="draggable-row-title">
              <span>{{ section.name || section.label }}</span>
            </div>

            <!-- Pop Menu  -->
            <div class="active-section-menu">
              <transition>
                <PopUpMenu
                  :visible="showMenuFromSection.id === section.id || section.id === sectionHover"
                  :options="getOptionsMenu(section)"
                  @click="handleSectionOptions(section.id, index)"
                  @clickOutside="() => { showMenuFromSection.id = null }"
                >
                <div :class="['active-section-options', {'isSectionMenuOpened': showMenuFromSection.id === section.id}]">
                  <v-icon size="12">fa-regular fa-ellipsis</v-icon>
                </div>
                </PopUpMenu>  
              </transition>              
            </div>
            <!-- End Pop Menu  -->
          </div>
        </div>
      </transition-group>
    </draggable>  

    <RenameDialog 
      type="section"
      objectKey="name"
      :objectToRename="sectionToRename"
      :isOpen="isRenameDialogOpen"
      :placeholder="sectionToRename ? types[sectionToRename.type] : ''"
      @onClose="isRenameDialogOpen = false"
    />

    <ConfirmDialog 
      v-model="isDeleteDialogOpen"
      title="Remoção de seção"
      :showTitleDivider="false"
      @confirmDone="confirmRemoveSection(sectionToDelete)"
    >
    <template v-if="sectionToDelete" slot="content">
      <div class="pt-2 pb-5">
        Deseja remover a seção <b>{{getNameOfSection()}}</b>? <br>Essa ação não poderá ser desfeita.
      </div>
    </template>
    </ConfirmDialog>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { generateId } from '../../../helpers/generateId'
import draggable from 'vuedraggable'
import PopUpMenu from '../../_v2/ui/PopUpMenu.vue'
import ConfirmDialog from '../../_v2/ui/ConfirmDialog.vue'
import RenameDialog from './RenameDialog.vue'

export default {
  name: 'MenuOptions',
  props: {
    types: {type: Object, required: true},
    handleCloseSection: {type: Function, required: true}
  },
  components: { draggable, PopUpMenu, RenameDialog, ConfirmDialog },
  computed: {
    ...mapGetters(['navbar', 'infos', 'editViewType', 'sectionHover', 'selectedPage']),

    configuredSections() {
      return this.infos.sections.map(section => {
        return {id: section.id, pageId: section.pageId, label: this.types[section.type], name: section.name}
      })
    },  

    sectionOptions () {
      const {id, index} = this.showMenuFromSection
      return [
        {label: 'Renomear', action: () => { this.renameSection(id, index) }},  
        {label: 'Duplicar seção', action: () => { this.duplicateSection(id, index) }},
        {label: 'Remover', action: () => { this.removeSection(id, index) }, divider: true}
      ]
    }  
  },

  data: () => ({
    showMenuFromSection: {id: null, index: null},
    isRenameDialogOpen: false,
    sectionToRename: null,
    sectionToDelete: null,
    isDeleteDialogOpen: false
  }),

  methods: {
    getOptionsMenu (section) {
      const cantBeDuplicatedList = ['menu', 'footer', 'cover']
      const isUnableToDuplicate = cantBeDuplicatedList.some(i => section.id.includes(i))
      if (isUnableToDuplicate) return this.sectionOptions.filter(item => item.label !== 'Duplicar seção')
      return this.sectionOptions
    },

    handleSectionOptions(id, index) {
      if (this.showMenuFromSection.id === id) {
        this.showMenuFromSection.id = null
        this.showMenuFromSection.index = null
        return
      }
      this.showMenuFromSection.id = id
      this.showMenuFromSection.index = index
    },

    renameSection(id, index) {
      const section = this.infos.sections.find(section => section.id === id)
      this.sectionToRename = section
      this.isRenameDialogOpen = true
    },

    duplicateSection(id, index) {
      const section = this.infos.sections.find(section => section.id === id)
      const getRealSectionId = this.infos.sections.findIndex(section => section.id === id)
      const sectionCopy = JSON.parse(JSON.stringify(section))
      sectionCopy.name = sectionCopy.name ? `${sectionCopy.name} cópia` : `${this.types[sectionCopy.type]} cópia`
      sectionCopy.id = generateId()
      this.infos.sections.splice(getRealSectionId + 1, 0, sectionCopy)
    },

    removeSection(id, index) {
      this.sectionToDelete = {id, index}
      this.isDeleteDialogOpen = true
    },

    getNameOfSection () {
      if (!this.sectionToDelete) return ''

      const section = this.infos.sections.find(section => section.id === this.sectionToDelete.id)
      const name = section.name || this.types[section.type]
      return name
    },

    confirmRemoveSection(sectionToDelete) {
      this.infos.sections = this.infos.sections.filter(section => section.id !== sectionToDelete.id)
      this.sectionToDelete = null
    },

    handleOpenSection(section) {
      if (this.showMenuFromSection.id) return

      if (this.navbar.sectionId !== section.id) this.$store.dispatch("setNav", { open: true, sectionId: section.id })
      else this.handleCloseSection()    

      const selectedSection = document.querySelector('.isSelected')
      if (selectedSection) {
        if (this.editViewType === 'desktop') window.scrollTo({top: selectedSection.offsetTop, behavior: "smooth"})
        if (this.editViewType === 'mobile') {
          const mobileView = document.querySelector('.device-view')
          mobileView.scrollTo({top: selectedSection.offsetTop - mobileView.offsetTop, behavior: 'smooth'})
        }
      }
    }
  }
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
  cursor: move !important
}

.active-section {
  box-shadow: inset 0 0 0 1px rgba(102, 109, 128, 0.3);
}

.active-section-menu {
  display: flex;
  flex: 1;
  justify-content: end;
  padding-right: 12px;
}

.active-section-menu /deep/ .active-section-options {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  padding: 2px;
  transition: all 0.3s;
  border-radius: 4px
}

.active-section-options:hover {
  background-color: #CBCBCE;
}

.isSectionMenuOpened {
  background-color: #CBCBCE;
}

.draggable-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(102, 109, 128, 0.05);
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(102, 109, 128, 0.1);
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;  
}

.draggable-row:hover {
  animation: changeCursor 2s forwards;
  box-shadow: inset 0 0 0 1px rgba(102, 109, 128, 0.3);
}

.draggable-row-icon {
  width: 32px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgba(102, 109, 128, 0.1);
  cursor: move;
}

.draggable-row-title {
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 700;
  font-family: Inter !important;
  color: #24252D
}

/* Animação lista  */
@keyframes changeCursor {
  100% {
    cursor: move;
  }
}

.list-complete-item {
  transition: all 0.8s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.list-complete-leave-active {
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
}
</style>